/*
  Utilitários de CPF compartilhados entre a tela de login e o
  cadastro de usuários: máscara progressiva (000.000.000-00) e
  limpeza para enviar só os dígitos ao backend.
*/

/* Remove tudo que não for dígito */
export function limparCpf(valor) {
  return String(valor || "").replace(/\D/g, "");
}

/* Aplica a máscara 000.000.000-00 conforme o usuário digita */
export function formatarCpf(valor) {
  const d = limparCpf(valor).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

/*
  Máscara para o campo de login, que aceita CPF OU e-mail:
  só aplica a máscara de CPF enquanto o texto for apenas
  dígitos/pontuação de CPF; qualquer letra ou @ mantém como digitado.
*/
export function formatarLogin(valor) {
  const texto = String(valor || "");
  if (/^[\d.\-\s]*$/.test(texto)) return formatarCpf(texto);
  return texto;
}
